export const CONTENT_BLOCKS = {
  CALL_TO_ACTION: 'content-blocks.call-to-action',
  GOOD_TO_KNOW: 'content-blocks.good-to-know',
  IMAGE: 'content-blocks.image',
  QUOTE: 'content-blocks.quote',
  RICH_TEXT: 'content-blocks.rich-text',
  TABLE: 'content-blocks.table',
  VIDEO: 'content-blocks.video',
  VIMEO: 'content-blocks.vimeo'
} as const
export type ContentBlockComponent = (typeof CONTENT_BLOCKS)[keyof typeof CONTENT_BLOCKS]

export enum CmsArticleTypes {
  ENCYCLOPEDIA = 'encyclopedia',
  BLOG_INTERNAL = 'blogInternal',
  BLOG_EXTERNAL = 'blogExternal'
}

export enum CmsPages {
  ENCYCLO_CATEGORY = 'encyclopedia-category',
  ENCYCLO_ARTICLE = 'encyclopedia-article',
  BLOG_ARTICLE = 'blog-article',
  FAQ_ARTICLE = 'faq-article',
  FAQ_CATEGORY = 'faq-category',
  JOB_OFFER = 'job-offer',
  PRICING = 'pricing-v2',
  PRODUCT_LANDINGSPAGE = 'product-landingspage',
  VIDEO_TESTIMONIAL = 'video-testimonial'
}

// Used to filter out FAQ questions in the FAQ Drawer based on certain conditions
export enum FaqTags {
  BILLING_CYCLES = 'billing-cycles',
  INSTALMENTS = 'instalments'
}
